<template>
  <status-waiting></status-waiting>
</template>

<script>
import StatusWaiting from "./status-order/waiting.vue";

export default {
  components: {
    StatusWaiting,
  },
};
</script>
